import { OrganisationUrlType, SanityEcosystemMember } from "../model/common";

export const organisationUrl = (
  organisation: SanityEcosystemMember,
  preferred: OrganisationUrlType
): string | undefined => {
  if (preferred === "omit") {
    return undefined;
  }
  const typesInOrder: OrganisationUrlType[] = [
    preferred,
    "about",
    "education",
    "reseller"
  ];
  for (const type of typesInOrder) {
    const value = urlByType(organisation, type);
    if (value) {
      return value;
    }
  }
  return undefined;
};

const urlByType = (
  organisation: SanityEcosystemMember,
  type: OrganisationUrlType
) => {
  switch (type) {
    case "about":
      return organisation.aboutUrl;
    case "education":
      return organisation.educationUrl;
    case "reseller":
      return organisation.resellerUrl;
    default:
      throw new Error(`Unknown type: ${type}`);
  }
};
